document.querySelectorAll('.search-component-toggle')?.forEach((toggle) => {
  const button = toggle.querySelector('button')
  const checkbox = toggle.querySelector('input[type="checkbox"]')
  const filterId = toggle.dataset.filterId
  const filterItemId = toggle.dataset.filterItemId

  button?.setAttribute('aria-checked', checkbox.checked)

  button?.addEventListener('click', (e) => {
    e.preventDefault()
    checkbox.checked = !checkbox.checked
    button.setAttribute('aria-checked', checkbox.checked)

    checkbox.dispatchEvent(
      new Event('input', { bubbles: true, composed: true })
    )

    if (checkbox.checked) {
      helpers.applyFilter(filterId, filterItemId)
    } else {
      helpers.clearFilter(filterId, filterItemId)
    }
  })
})

const clearAllButton = document.querySelector(
  '.search-landing__filter-drawer-footer-button-group a'
)

clearAllButton?.addEventListener('click', () => {
  const appliedFilters = helpers.getAppliedFilters(true)

  appliedFilters?.forEach((appliedFilter) => {
    appliedFilter.items?.forEach((item) => {
      helpers.clearFilter(appliedFilter.id, item.id)
    })
  })

  document.querySelectorAll('.search-component-toggle')?.forEach((toggle) => {
    const checkbox = toggle.querySelector('input[type="checkbox"]')
    const button = toggle.querySelector('button')

    if (checkbox.checked) {
      checkbox.checked = false
      button.setAttribute('aria-checked', false)
    }
  })
})
